import { combineReducers } from 'redux';

import templatesFilters from './templatesFilters';

export default combineReducers({
  templatesFilters,
});
